// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const CloseBigIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor"><path d="M18 19a1 1 0 01-.71-.29l-12-12a1 1 0 011.42-1.42l12 12a1 1 0 010 1.42A1 1 0 0118 19z"/><path d="M6 19a1 1 0 01-.71-.29 1 1 0 010-1.42l12-12a1 1 0 111.42 1.42l-12 12A1 1 0 016 19z"/></g></svg>'} />;

(CloseBigIcon as any).displayName = 'CloseBigIcon';

export default CloseBigIcon;
